import { render, staticRenderFns } from "./sendCT.vue?vue&type=template&id=4309e348&scoped=true&"
import script from "./sendCT.vue?vue&type=script&lang=js&"
export * from "./sendCT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4309e348",
  null
  
)

export default component.exports